'use strict';

export default {
  getAlertList(state) {
    return state.list;
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/alerts-float/getters.js